import { FindStore as FindStoreComponent } from 'modules/findStore';
import { withErrorBoundary } from 'react-error-boundary';

function FindStore() {
    return <FindStoreComponent />;
}

export default withErrorBoundary(FindStore, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
